import FormDrawer from "components/__new/common/form-drawer";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { ReactComponent as IconsPlusRectangle } from "assets/images/icons/project-icons/add-rectangle.svg";
import { ReactComponent as IconsMinusRectangle } from "assets/images/icons/project-icons/clear-rectangle.svg";
import CurrencyFormat from "utils/currencyFormat";
import NumberFormat from "utils/numberFormat";
import pluralize from "utils/pluralize";


export const TransactionDetails = (props) => {
    const { isOpen, setIsOpen, transaction } = props;


    return (
        <FormDrawer isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="min-h-screen bg-white">
                <div className="pb-24">


                    <div className="p-6  bg-[#F9FAFB]">
                        <div className="flex justify-between">
                            <div></div>
                            <div onClick={() => setIsOpen(false)} className="modal-close group">
                                <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                            </div>
                        </div>
                        
                        <div className="mt-6 flex items-end justify-between">
                            <div className="w-full sm:w-1/2">
                                <div className="font-medium text-2xl">
                                    {transaction?.employee_name || "-"}
                                </div>
                                <div className="mt-1 text-fade-3 text-sm">
                                    {transaction?.employee_number || "-"}
                                </div>
                            </div>
                            <div className="w-full sm:w-1/2 text-right">
                                <div className="text-fade-3 text-sm">
                                    Net Pay
                                </div>
                                <div className="mt-1 font-medium text-2xl">
                                    {CurrencyFormat(transaction?.net_pay, "no-kobo") || "-"}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="pt-0 box">
                        <div className="pt-6 pb-3 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Workdays
                            </div>
                            <div className="font-medium">
                                {NumberFormat(transaction?.days_worked, "no-kobo") || "-"} {pluralize(transaction?.days_worked, "Day", "Days")}
                            </div>
                        </div>

                        <div className="py-3 mt-4 mb-2 flex space-x-4 justify-between items-center border-t border-b border-gray-200">
                            <div className="text-ep-primary-600 flex items-center font-medium">
                                <IconsPlusRectangle className="mr-3" />
                                EARNINGS 
                            </div>
                            <div className="text-sm text-fade-3">
                                AMOUNT
                            </div>
                        </div>

                        <div className="py-2 text-sm flex items-center font-medium">
                            Salary Breakdown
                        </div>

                        {transaction?.salary_component_amounts !== undefined && ["basic", "housing", "transport"].map((key) =>
                            <div key={key} className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3 capitalize">
                                    {key}
                                </div>
                                <div className="font-medium">
                                    {CurrencyFormat(transaction?.salary_component_amounts[key], "no-kobo") || "-"}
                                </div>
                            </div>
                        )}

                        {transaction?.salary_component_amounts === undefined &&
                            <div className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    -
                                </div>
                                <div className="font-medium">
                                    -
                                </div>
                            </div>
                        }

                        <div className="py-2 text-sm flex items-center font-medium">
                            Benefits
                        </div>

                        {transaction?.benefits_in_kind?.length > 0 && transaction?.benefits_in_kind?.map((benefit) =>
                            <div key={benefit?.id} className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    {benefit?.name || "-"}
                                </div>
                                <div className="font-medium">
                                    {CurrencyFormat(benefit?.value, "no-kobo") || "-"}
                                </div>
                            </div>
                        )}

                        {(transaction?.benefits_in_kind === undefined || transaction?.benefits_in_kind?.length === 0) &&
                            <div className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    -
                                </div>
                                <div className="font-medium">
                                    -
                                </div>
                            </div>
                        }

                        <div className="py-2 text-sm flex items-center font-medium">
                            Allowance
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Manual Bonus
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.manual_bonuses, "no-kobo") || "-"}
                            </div>
                        </div>
                            
                        {transaction?.allowances_and_bonuses?.length > 0 && transaction?.allowances_and_bonuses?.map((allowance_and_bonus) =>
                            <div key={allowance_and_bonus?.id} className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    {allowance_and_bonus?.name || "-"}
                                </div>
                                <div className="font-medium">
                                    {CurrencyFormat(allowance_and_bonus?.value, "no-kobo") || "-"}
                                </div>
                            </div>
                        )}

                        {/* 
                        {(transaction?.allowances_and_bonuses === undefined || transaction?.allowances_and_bonuses?.length === 0) &&
                            <div className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    -
                                </div>
                                <div className="font-medium">
                                    -
                                </div>
                            </div>
                        }
                        */}
                         

                        {/* 
                        <div className="py-2 text-sm flex items-center font-medium">
                            Custom
                        </div>

                        {transaction?.earnings_breakdown?.custom_earnings?.map((custom_earning) =>
                            <div key={custom_earning?.name} className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    {custom_earning?.name || "-"}
                                </div>
                                <div className="font-medium">
                                    {CurrencyFormat(custom_earning?.amount, "no-kobo") || "-"}
                                </div>
                            </div>
                        )}

                        {(transaction?.earnings_breakdown?.custom_earnings === undefined || transaction?.earnings_breakdown?.custom_earnings?.length === 0) &&
                            <div className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    -
                                </div>
                                <div className="font-medium">
                                    -
                                </div>
                            </div>
                        }
                        */}

                        <div className="py-3 mt-4 mb-2 flex space-x-4 justify-between items-center border-t border-b border-gray-200">
                            <div className="text-[#DC2626] flex items-center font-medium">
                                <IconsMinusRectangle className="mr-3" />
                                DEDUCTIONS 
                            </div>
                            <div className="text-sm text-fade-3">
                                AMOUNT
                            </div>
                        </div>

                        <div className="py-2 text-sm flex items-center font-medium">
                            Pre Tax Deduction
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Pension (Employee contribution)
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.pension_deduction?.employee_amount, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Pension (Employer contribution)
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.pension_deduction?.employer_amount, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                NHF
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.nhf, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                NSITF
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.nsitf, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                ITF
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.itf, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 text-sm flex items-center font-medium">
                            Tax Deduction
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Income Tax
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.paye_tax, "no-kobo") || "-"}
                            </div>
                        </div>

                        <div className="py-2 text-sm flex items-center font-medium">
                            Post Tax Deduction
                        </div>
                        
                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                Manual Deduction
                            </div>
                            <div className="font-medium">
                                {CurrencyFormat(transaction?.manual_deductions, "no-kobo") || "-"}
                            </div>
                        </div>
                        
                        {transaction?.custom_deductions?.length > 0 && transaction?.custom_deductions?.map((custom_deduction) =>
                            <div key={custom_deduction?.pay_structure_id} className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    {custom_deduction?.name || "-"}
                                </div>
                                <div className="font-medium">
                                    {CurrencyFormat(custom_deduction?.value, "no-kobo") || "-"}
                                </div>
                            </div>
                        )}

                        {/*
                        {(transaction?.custom_deductions === undefined || transaction?.custom_deductions?.length === 0) &&
                            <div className="py-2 flex space-x-4 justify-between items-center">
                                <div className="text-sm text-fade-3">
                                    -
                                </div>
                                <div className="font-medium">
                                    -
                                </div>
                            </div>
                        }
                        */}

                        {/* 
                        <div className="py-2 text-sm flex items-center font-medium">
                            Custom
                        </div>

                        <div className="py-2 flex space-x-4 justify-between items-center">
                            <div className="text-sm text-fade-3">
                                -
                            </div>
                            <div className="font-medium">
                                -
                            </div>
                        </div>
                        */}


                    </div>


                </div>
            </div>
        </FormDrawer>
    )
}